import { type OffersResponseData } from './types';

interface UseOfferClickoutService {
  apiKey: string;
  clickoutOrigin: string;
  clickoutServiceUrl?: string;
  deviceType?: string;
  fullPageUrl?: string;
  gtmId?: string | null;
  offers?: OffersResponseData | null;
  pageUrl?: string;
  recommendedMarketId?: string;
  shouldUseClickoutService: boolean;
}

export function useOfferClickoutService({
  apiKey,
  clickoutOrigin,
  clickoutServiceUrl,
  deviceType,
  fullPageUrl,
  gtmId,
  offers,
  pageUrl,
  recommendedMarketId,
  shouldUseClickoutService,
}: UseOfferClickoutService) {
  if (!shouldUseClickoutService || !clickoutServiceUrl) {
    return offers ?? [];
  }

  if (!offers?.length) {
    return [];
  }

  return offers.map((item, index) => {
    const params: Record<string, string | undefined | null> = {
      apiKey,
      clickoutOrigin,
      containerId: gtmId,
      deviceType,
      fullPageUrl,
      offerId: String(item?.id),
      offerPosition: String(index),
      pageUrl,
      recommendedMarketId,
    };

    const url = new URL(clickoutServiceUrl);

    const searchParams = url.searchParams;

    for (const [key, value] of Object.entries(params)) {
      if (value != null) {
        searchParams.set(key, value);
      }
    }

    url.search = searchParams.toString();

    return {
      ...item,
      clickOutUrl: url.toString(),
    };
  });
}
